<template>
  <div class="team-invite">
    <button
      :disabled="disabled"
      @click="showMemberForm = true"
      class="team-invite__btn"
      :class="{ 'team-invite__btn--disabled': disabled }"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1V15M1 8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      {{ title }}
    </button>
    <Teleport to="#teleport-modal">
      <AddTeamMember
        v-if="showMemberForm"
        @close-modal="showMemberForm = false"
        @success="toggleSuccessModal"
      />
      <SuccessModal
        v-if="showSuccessModal"
        @close="closeSuccessModal"
        :show="showSuccessModal"
        v-bind="{
          title: 'Success',
          body: 'You have added this user to your team.They have been notified via the provided email.',
        }"
      />
    </Teleport>
  </div>
</template>
  
  <script setup>
import AddTeamMember from "./AddTeamMember.vue";
import SuccessModal from "@/components/general/SuccessModal.vue";
import { useStore } from "vuex";
import { onBeforeUnmount, ref } from "vue";

const store = useStore();

const emit = defineEmits(["member-added"]);

const props = defineProps({
  title: {
    type: String,
    default: () => "",
    required: true,
  },
  buttonType: {
    type: String,
    required: false,
    default: () => "",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const triggeredBy = ref(0);
const btnLoading = ref(false);
const showMemberForm = ref(false);
const showSuccessModal = ref(false);

const toggleSuccessModal = () => {
  showSuccessModal.value = true;
  showMemberForm.value = false;

  emit("member-added");
};

const closeSuccessModal = async () => {
  showSuccessModal.value = false;
};

</script>
  
<style lang="scss" scoped>
$btn-primary: #001240;
$btn-disabled: #94A3B8;

.team-invite {
  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    padding: 0 20px;
    background: $btn-primary;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover:not(:disabled) {
      background: lighten($btn-primary, 8%);
    }

    &--disabled {
      background: $btn-disabled;
      cursor: not-allowed;
    }

    svg {
      flex-shrink: 0;
    }
  }
}
</style>